import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { ExploreImageSuggestion, HttpResponse } from "@/types";

// Asks guac's model to propose a photo's details before it's uploaded.
// Stores nothing, so there's no query to invalidate.
export function useSuggestExploreImageDetails() {
  const mutation = useMutation({
    mutationFn: async (image: File) => {
      const res = await guacHttpClient.postForm<
        ExploreImageSuggestion,
        HttpResponse<ExploreImageSuggestion>
      >("explore-images/suggestions", { image });

      return res.data;
    },
  });

  return mutation;
}
